import FormNewChanges from "../../base/actions/FormNewChanges";

const formNewChanges: FormNewChanges = {
    changeRequestFinishedTitle: "Request to change {type} completed.",
    updatedFromPlcTitle: "The values ​​of {type} have changed directly on the PLC.",
    dialogMessage: "Do you want to load the current values?",
}

export default formNewChanges;